import { DateTime } from 'luxon';

import { CompanyReportType } from '../../CompanyReport';
import { RecurringCompanyReport } from '../../RecurringCompanyReport';
import { Timezone } from '../../Time';
import { EDITED_REPORT_DELIVERY_HOUR } from '../EditedReportDeliveryHour';

export const FHA_TIMEZONE: Timezone = 'America/New_York' as const;

// US federal holidays — FHA follows the standard federal holiday calendar

export const FHA_HOLIDAYS: DateTime[] = [
  // 2025
  DateTime.fromObject({ year: 2025, month: 1, day: 1 }), // New Year's Day
  DateTime.fromObject({ year: 2025, month: 1, day: 20 }), // Martin Luther King Jr. Day
  DateTime.fromObject({ year: 2025, month: 2, day: 17 }), // Presidents' Day
  DateTime.fromObject({ year: 2025, month: 5, day: 26 }), // Memorial Day
  DateTime.fromObject({ year: 2025, month: 6, day: 19 }), // Juneteenth
  DateTime.fromObject({ year: 2025, month: 7, day: 4 }), // Independence Day
  DateTime.fromObject({ year: 2025, month: 9, day: 1 }), // Labor Day
  DateTime.fromObject({ year: 2025, month: 10, day: 13 }), // Columbus Day
  DateTime.fromObject({ year: 2025, month: 11, day: 11 }), // Veterans Day
  DateTime.fromObject({ year: 2025, month: 11, day: 27 }), // Thanksgiving Day
  DateTime.fromObject({ year: 2025, month: 12, day: 25 }), // Christmas Day

  // 2026
  DateTime.fromObject({ year: 2026, month: 1, day: 1 }), // New Year's Day
  DateTime.fromObject({ year: 2026, month: 1, day: 19 }), // Martin Luther King Jr. Day
  DateTime.fromObject({ year: 2026, month: 2, day: 16 }), // Presidents' Day
  DateTime.fromObject({ year: 2026, month: 5, day: 25 }), // Memorial Day
  DateTime.fromObject({ year: 2026, month: 6, day: 19 }), // Juneteenth
  DateTime.fromObject({ year: 2026, month: 7, day: 3 }), // Independence Day (Observed)
  DateTime.fromObject({ year: 2026, month: 9, day: 7 }), // Labor Day
  DateTime.fromObject({ year: 2026, month: 10, day: 12 }), // Columbus Day
  DateTime.fromObject({ year: 2026, month: 11, day: 11 }), // Veterans Day
  DateTime.fromObject({ year: 2026, month: 11, day: 26 }), // Thanksgiving Day
  DateTime.fromObject({ year: 2026, month: 12, day: 25 }), // Christmas Day

  // 2027
  DateTime.fromObject({ year: 2027, month: 1, day: 1 }), // New Year's Day
  DateTime.fromObject({ year: 2027, month: 1, day: 18 }), // Martin Luther King Jr. Day
  DateTime.fromObject({ year: 2027, month: 2, day: 15 }), // Presidents' Day
  DateTime.fromObject({ year: 2027, month: 5, day: 31 }), // Memorial Day
  DateTime.fromObject({ year: 2027, month: 6, day: 18 }), // Juneteenth (Observed)
  DateTime.fromObject({ year: 2027, month: 7, day: 5 }), // Independence Day (Observed)
  DateTime.fromObject({ year: 2027, month: 9, day: 6 }), // Labor Day
  DateTime.fromObject({ year: 2027, month: 10, day: 11 }), // Columbus Day
  DateTime.fromObject({ year: 2027, month: 11, day: 11 }), // Veterans Day
  DateTime.fromObject({ year: 2027, month: 11, day: 25 }), // Thanksgiving Day
  DateTime.fromObject({ year: 2027, month: 12, day: 24 }), // Christmas Day (Observed)
] as const;

export const FHA_DEFAULT_RECURRING_REPORT_VALUES: Record<
  CompanyReportType.FHA_TS_264 | CompanyReportType.FHA_TS_264_EDIT,
  Pick<RecurringCompanyReport, 'deliveryHour' | 'deliveryTimeZone' | 'title'> & { deliveryDay: number }
> = {
  FHA_TS_264: {
    deliveryHour: 5,
    deliveryTimeZone: FHA_TIMEZONE,
    title: 'FHA TS 264',
    deliveryDay: 3,
  },
  FHA_TS_264_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: FHA_TIMEZONE,
    title: 'FHA TS 264 (Edits)',
    deliveryDay: 0,
  },
} as const;
